var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "RealTimeQuality" },
    [
      _c(
        "div",
        { staticClass: "Escalation" },
        [
          _c("span", { staticClass: "time" }, [
            _vm._v("上次成功上报：" + _vm._s(_vm.logCreateTime)),
          ]),
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "small" },
              on: {
                click: function ($event) {
                  return _vm.sendLog()
                },
              },
            },
            [_vm._v("日志上报\n    ")]
          ),
        ],
        1
      ),
      _c(
        "el-tabs",
        {
          on: { "tab-click": _vm.handleClick },
          model: {
            value: _vm.activeName,
            callback: function ($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName",
          },
        },
        [
          _c("el-tab-pane", { attrs: { label: "帧率", name: "Frame" } }),
          _c("el-tab-pane", { attrs: { label: "码率", name: "Code" } }),
          _c("el-tab-pane", { attrs: { label: "丢包率", name: "Packet" } }),
          _c("el-tab-pane", { attrs: { label: "时延", name: "delay" } }),
          _vm.$route.query.dType != 5 && _vm.$route.query.dType != 6
            ? _c("el-tab-pane", { attrs: { label: "CPU 使用率", name: "CPU" } })
            : _vm._e(),
          _vm.$route.query.dType != 5 && _vm.$route.query.dType != 6
            ? _c("el-tab-pane", {
                attrs: { label: "内存占用", name: "Memory" },
              })
            : _vm._e(),
        ],
        1
      ),
      _c("div", { attrs: { id: "cechart" } }),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "日志上报",
            visible: _vm.logDialogVisible,
            width: "500px",
            "close-on-click-modal": true,
            "close-on-press-escape": true,
            "append-to-body": true,
            "modal-append-to-body": true,
            "lock-scroll": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.logDialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            [
              _c(
                "el-form",
                { attrs: { "label-width": "100px" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "问题描述：" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          rows: 4,
                          placeholder: "请输入问题描述",
                          maxlength: "500",
                          "show-word-limit": "",
                        },
                        model: {
                          value: _vm.faultDescription,
                          callback: function ($$v) {
                            _vm.faultDescription = $$v
                          },
                          expression: "faultDescription",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.logDialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.logLoading },
                  on: { click: _vm.confirmSendLog },
                },
                [_vm._v("上报")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }